import { render, staticRenderFns } from "./EntityFiles.vue?vue&type=template&id=9624608c&scoped=true&"
import script from "./EntityFiles.vue?vue&type=script&lang=ts&"
export * from "./EntityFiles.vue?vue&type=script&lang=ts&"
import style0 from "./EntityFiles.vue?vue&type=style&index=0&id=9624608c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9624608c",
  null
  
)

export default component.exports